module.exports = __webpack_public_path__ + "static/media/close-all.0a45823d.svg";